import { render } from "./AccountDeletion.vue?vue&type=template&id=2ec3607b&scoped=true&ts=true"
import script from "./AccountDeletion.vue?vue&type=script&lang=ts"
export * from "./AccountDeletion.vue?vue&type=script&lang=ts"

import "./AccountDeletion.vue?vue&type=style&index=0&id=2ec3607b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec3607b"]])

export default __exports__